import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { PageContent } from './components/PageContent';

const EdutainmentCheckIn = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="育樂活動簽到"
          breadcrumbs={[
            {
              name: '育樂活動',
            },
            {
              name: '育樂活動簽到',
            },
          ]}
        />
        <PageContent />
      </Col>
    </Row>
  );
};

export default EdutainmentCheckIn;
